import type { SegmentProviderConfig } from '@openx/components-segment/lib/utils/context/SegmentContext';

import { useAccountOptionsFetch } from './utils/useAccountOptionsFetch';
import { useCreateLookalikeSegment } from './utils/useCreateLookalikeSegment';
import { useLalSegmentFetch } from './utils/useLalSegmentFetch';
import { useLalSegmentPermissions } from './utils/useLalSegmentPermissions';
import { useLalSegmentsListFetch } from './utils/useLalSegmentsListFetch';
import { useLalSegmentsOperation } from './utils/useLalSegmentsOperation';
import { useLalSegmentsWithDetails } from './utils/useLalSegmentsWithDetails';
import { useLalSegmentsWithDetailsFetch } from './utils/useLalSegmentsWithDetailsFetch';
import { useLalSegmentTableFetch } from './utils/useLalSegmentTableFetch';
import { useProvidersListFetch } from './utils/useProvidersListFetch';
import { useSegmentReachFetch } from './utils/useSegmentReachFetch';
import { useSegmentsEstimatedReachFetch } from './utils/useSegmentsEstimatedReachFetch';
import { useSegmentsInfinityScrollListFetch } from './utils/useSegmentsInfinityScrollListFetch';
import { useSegmentsLinkedAudiences } from './utils/useSegmentsLinkedAudiences';
import { useSegmentsLinkedAudiencesFetch } from './utils/useSegmentsLinkedAudiencesFetch';
import { useSegmentsListFetch } from './utils/useSegmentsListFetch';
import { useSegmentsOperation } from './utils/useSegmentsOperation';
import { useSegmentTableFetch } from './utils/useSegmentTableFetch';
import { useUpdateLookalikeSegment } from './utils/useUpdateLookalikeSegment';
import { useUploadSegment } from './utils/useUploadSegment';

export const segmentConfig: SegmentProviderConfig = {
  isOa: true,
  useAccountOptionsFetch,
  useSegmentReachFetch,
  useSegmentTableFetch,
  useSegmentsLinkedAudiences,
  useSegmentsLinkedAudiencesFetch,
  useSegmentsListFetch,
  useSegmentsOperation,
  useUploadSegment,
  useProvidersListFetch,
  useLalSegmentTableFetch,
  useLalSegmentsListFetch,
  useLalSegmentsOperation,
  useLalSegmentsWithDetails,
  useLalSegmentsWithDetailsFetch,
  useLalSegmentFetch,
  useCreateLookalikeSegment,
  useLalSegmentPermissions,
  useUpdateLookalikeSegment,
  useSegmentsEstimatedReachFetch,
  useSegmentsInfinityScrollListFetch,
};
